export default "__VITE_ASSET__8ab6c49c__"